import { RequestBodyType, RequestMethod } from "lib/api-types";
import { baseApiUrl } from "redux/reducers/settings";

const baseUrl = baseApiUrl;

export const dashboardApi = {
    ongoingTraining: {
        actionName: "ONGOING_TRAINING",
        controllerName: `${baseUrl}users/admin/routines`,
        requestMethod: RequestMethod.GET,
    },

    dashboardCount: {
        actionName: "DASHBOARD_COUNT",
        controllerName: `${baseUrl}training/admin/dashboard/count`,
        requestMethod: RequestMethod.GET,
    },




    //   GetBranchDropdown: {
    //     actionName: "GET_BRANCH_DROPDOWN",
    //     controllerName: `${baseUrl}/BranchApi/GetBranchForDropdown`,
    //     requestMethod: RequestMethod.GET,
    //   },
    //   AddShift: {
    //     actionName: "ADD_SHIFT",
    //     controllerName: `${baseUrl}/ShiftApi/post`,
    //     requestMethod: RequestMethod.POST,
    //   },
    //    UpdateShift: {
    //     actionName: "UPDATE_SHIFT",
    //     controllerName: `${baseUrl}/ShiftApi/put`,
    //     requestMethod: RequestMethod.PUT,
    //   },
    //   GetShiftById: {
    //     actionName: "GET_SHIFT_BY_ID",
    //     controllerName: `${baseUrl}/ShiftApi/GetShiftById`,
    //     requestMethod: RequestMethod.GET,
    //   },
    //    DeleteShiftById: {
    //     actionName: "DELETE_SHIFT_BY_ID",
    //     controllerName: `${baseUrl}/ShiftApi/delete`,
    //     requestMethod: RequestMethod.DELETE,
    //   },
};